import Vue from 'vue';
import Vuex from 'vuex';
import login from './modules/login';
import view from './modules/view';
import power from './modules/power';
import router from './modules/router'
import getters from './getters';
import goods from './modules/goods'
import { Navigate } from '../assets/utils/navigate';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    login,
    view,
    router,
    power,
    goods
  },
  getters,
  state: {
    cachePages: [],
    cachePagesList: [],
    currentPage: '',
  },
  mutations: {
    addCachePage(state, data) {
      const list = JSON.parse(JSON.stringify(state.cachePages));
      if (list.indexOf(data.component.name) < 0) {
        list.push(data.component.name);
        state.cachePagesList.push(data.component);
        state.cachePages = list;
      }
    },
    removeCachePage(state, data) {
      const list = JSON.parse(JSON.stringify(state.cachePages));
      const index = list.indexOf(data.component.name);
      if (index > -1) {
        if (list.length === 1) {
          Navigate.route.push('/home');
        } else if (index === 0 && list.length > 1) {
          Navigate.route.push(state.cachePagesList[index + 1].path);
        } else if (data.component.name === state.currentPage) {
          Navigate.route.push(state.cachePagesList[index - 1].path);
        }
        const foundIndex = state.cachePagesList.findIndex(item => item.name === data.component.name);
        if (foundIndex > -1) {
          state.cachePagesList.splice(foundIndex, 1);
        }
        list.splice(index, 1);
        state.cachePages = list;
      }
    },
    clearCachePages(state) {
      state.cachePagesList = [];
      state.cachePages = [];
    },
    setCurrentPage(state, data) {
      state.currentPage = data.component.name;
    }
  }
});

export default store